import {useTranslation} from "react-i18next";
import {Route} from "../types";
import Home from "../pages/Home/Home";
import Projects from "../pages/Projects/Projects";
import PDFResume from "../components/PDFResume/PDFResume";
import Contact from "../pages/Contact/Contact";

export const useRoutes = () => {
  const {t} = useTranslation();

  const routes: Route[] = [
    {
      name: t("navbar.home"),
      to: "/",
      Element: Home,
    },
    {
      name: t("navbar.projects"),
      to: "/projects",
      Element: Projects,
    },
    {
      name: t("navbar.contact"),
      to: "/contact",
      Element: Contact,
    },
    {
      name: t("navbar.resume"),
      to: "/resume",
      Element: PDFResume,
    },
  ];

  return {
    routes,
  };
};
